import { post } from "./api";

export const getIndeedDescription = (id) => async (dispatch) => {
  try {
    // NO Response implemented yet
    /* eslint-disable */
    const { jobs } = await post("/jobs/query/indeed_job_description", {
    /* eslint-enable */
      data: {
        "job_id": id
      }
    });
    if(jobs && jobs){
      return jobs
    }

  } catch (error) {
    console.log(error);
    // TODO
  }
};

export const getReedDescription = (id) => async (dispatch) => {
  try {
    // NO Response implemented yet
    /* eslint-disable */
    const { jobs } = await post("/jobs/query/reed_job_details", {
    /* eslint-enable */
      "id": id
    });
    if(jobs && jobs.jobDescription){
      return jobs.jobDescription
    }

  } catch (error) {
    console.log(error);
    // TODO
  }
};

export const getAutomationTooling = (occupation) => async (dispatch) => {
  try {
    const { jobs } = await post("/jobs/query/automation_tools", {
      occupation:occupation
    });
    
    if(jobs && jobs.tools){
      return jobs.tools
    }

  } catch (error) {
    console.log(error);
  }
};